export const CUSTOMER_SELECTOR_QUERY_PARAMS = { page_size: 50, page: 1 };

export const EXPLO_EUG_STORAGE_KEY = 'explo_customer';
